export default __webpack_public_path__ + "static/media/WheelMaintenance2.59a6e0b9.png";